/**
 * @param {string} url
 * @param {object} formParams
 * @param {object} options
 */
export default function buildAndSubmitForm(url, formParams = {}, options) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    Object.entries(formParams).forEach(([name, value]) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = name;
        hiddenField.value = value;
        form.appendChild(hiddenField);
    });
    if (options?.openInNewTab) {
        form.setAttribute('target', '_blank');
    }
    document.body.appendChild(form);
    form.submit();
}
